import Slideout from 'slideout';

const imageIsLoaded = (el) => {
	window.addEventListener("load", event => {
		const image = document.querySelector(el);
		return image.complete && image.naturalHeight !== 0;
	});
}

const initSlideout = () => {

	let toggler = document.querySelector('.js-toggle-slideout');

	const slideoutOptions = {
		'panel': document.querySelector('.js-slideout-panel'),
		'menu': document.querySelector('.js-slideout-menu'),
		// 'padding': document.querySelector('html').offsetWidth,
		'padding': 290,
		'tolerance': 70,
		'side': 'right'
	}

	let slideout = new Slideout(slideoutOptions);

	let close = (eve) => {
		eve.preventDefault();
		slideout.close();
	};

	document.querySelector('.js-slideout-close').addEventListener('click', close);

	slideout
		.on('beforeopen', function () {
			this.panel.classList.add('panel-open');
		})
		.on('open', function () {
			this.panel.addEventListener('click', close);

		})
		.on('beforeclose', function () {
			this.panel.classList.remove('panel-open');
			this.panel.removeEventListener('click', close);
		});

	const setBodyPadding = (el, togglerHeight) => {
		document.querySelector(el).style.paddingTop = togglerHeight + 'px';
	};

	const fixed = document.querySelector('.page-header-fixed');

	slideout.on('translate', function(translated) {
		fixed.style.transform = 'translateX(' + translated + 'px)';
	});

	slideout.on('beforeopen', function () {
		fixed.style.transition = 'transform 300ms ease';
		fixed.style.transform = `translateX(-${slideoutOptions.padding}px)`;
	});

	slideout.on('beforeclose', function () {
		fixed.style.transition = 'transform 300ms ease';
		fixed.style.transform = 'translateX(0px)';
	});

	slideout.on('open', function () {
		fixed.style.transition = '';
	});

	slideout.on('close', function () {
		fixed.style.transition = '';
	});


	// ready((cb) => {
	// 	/* Do things after DOM has fully loaded */
	// 	// console.log(cb);
	//
	// 	window.addEventListener("load", event => {
	// 		let image = document.querySelector('.logo img');
	// 		let isLoaded = image.complete && image.naturalHeight !== 0;
	//
	// 		const customOffeset = (-2);
	// 		const pageHeaderHeight = (document.querySelector('.js-page_header').offsetHeight) + customOffeset;
	// 		setBodyPadding('.js-slideout-menu', pageHeaderHeight);
	// 		setBodyPadding('.js-slideout-panel', pageHeaderHeight);
	// 	});
	// });

	// Events
	toggler.addEventListener('click', function () {
		slideout.toggle();
	});

}

export default initSlideout;
